<template>
  <Layout kind="narrow">
    <div class="section">
      <!-- <div class="content">
        <h1>{{ $t("Browse tags") }}</h1>
        <hr />
        <ul v-for="entry in facets" class="is-unstyled">
          <li>
            <RouterLink :to="{ name: 'Tags', query: { type: entry.value } }">
              {{ entry.value }} ({{ entry.count }} results)
            </RouterLink>
          </li>
          <hr />
        </ul>
      </div> -->
      <div class="title">{{ $t("Browse Tags") }}</div>
      <hr />
      <b-collapse
        class="card"
        animation="slide"
        v-for="(entry, index) of facets"
        :key="index"
        :open="isOpen == index"
        @open="fetchTags(entry)"
      >
        <div
          v-if="entry.value == 'person' || entry.value == 'place'"
          slot="trigger"
          slot-scope="props"
          class="card-header"
          role="button"
        >
          <p class="card-header-title">
            {{ $t(entry.value) }} ({{ entry.count }} {{ $t("results") }})
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
          </a>
        </div>
        <div class="card-content">
          <b-tabs type="is-boxed">
            <b-tab-item :label="$t('Attributes')" icon="tags" v-if="entry.value == 'person'">
              <div v-if="entry.value == 'person'">
                <a>
                  <b-table
                    :data="resultsPerson"
                    :per-page="itemsPerPage"
                    :paginated="true"
                    :columns="personColumns"
                    @click="selected($event, entry)"
                  >
                  </b-table>
                </a>
              </div>
              <div v-else>
                <a>
                  <b-table
                    :data="resultsPlace"
                    :per-page="itemsPerPage"
                    :paginated="true"
                    :columns="placeColumns"
                    @click="selected($event, entry)"
                  >
                  </b-table>
                </a>
              </div>
            </b-tab-item>
            <b-tab-item :label="$t('Tags')" icon="sort-alpha-down">
              <a>
                <b-table
                  :data="subFacets"
                  :per-page="itemsPerPage"
                  :paginated="true"
                  :columns="columns"
                  @click="selectedIndex($event, entry)"
                >
                </b-table>
              </a>
            </b-tab-item>
          </b-tabs>
        </div>
      </b-collapse>
    </div>
  </Layout>
</template>

<script>
import fillMissingKeys from "object-fill-missing-keys";

export default {
  data() {
    return {
      facets: [],
      resultsPerson: [],
      resultsPlace: [],
      isOpen: null,
      subFacets: [],
      itemsPerPage: 10,
      columns: [
        {
          field: "value",
          label: this.$t("Value"),
          numeric: false,
          searchable: true,
          sortable: true,
        },
        {
          field: "count",
          label: this.$t("Results"),
          numeric: true,
          sortable: true,
        },
      ],
      placeColumns: [
        {
          field: "cA_placeName",
          label: this.$t("Placename"),
          searchable: true,
          sortable: true,
        },
        {
          field: "count",
          label: this.$t("Results"),
          sortable: true,
        },
      ],
      personColumns: [
        {
          field: "cA_firstname",
          label: this.$t("Firstname"),
          searchable: true,
          sortable: true,
        },
        {
          field: "cA_lastname",
          label: this.$t("Lastname"),
          searchable: true,
          sortable: true,
        },
        {
          field: "count",
          label: this.$t("Results"),
          sortable: true,
        },
      ],
    };
  },
  methods: {
    async fetchTags(entry) {
      let { total, results, facets } = await this.api.fetchTagResults({
        limit: 10000,
        type: entry.value,
        facets: "value",
      });
      this.subFacets = facets.value;
      if (entry.value == "person") {
        results = this.setMissingPersonFacets(results);
        results = results.filter((item) => item.cA_firstname !== "");
        this.resultsPerson = results;
      } else {
        results = this.setMissingPlaceFacets(results);
        results = results.filter((item) => item.cA_name !== "");
        this.resultsPlace = results;

      }
    },
    selected(item, entry) {
      let routeData;
      if (item.type == "person") {
        routeData = this.$router.resolve({
          name: "Tags",
          query: {
            cA_firstname: item.cA_firstname,
            cA_lastname: item.cA_lastname,
            type: entry.value,
          },
        });
      } else {
        routeData = this.$router.resolve({
          name: "Tags",
          query: { cA_placeName: item.cA_placeName, type: entry.value },
        });
      }
      window.open(routeData.href, "_blank");
    },
    selectedIndex(item, entry) {
      console.log(entry);
      console.log(item);
      let routeData = this.$router.resolve({
        name: "Tags",
        query: { v: item.value, type: entry.value },
      });
      window.open(routeData.href, "_blank");
    },
    setMissingPersonFacets(results) {
      for (var result in results) {
        results[result] = fillMissingKeys(results[result], {
          cA_firstname: "",
          cA_lastname: "",
          cA_nameaddition: "",
        });
        var word = results[result].cA_nameaddition[0];
        if (word) {
          results[result].cA_nameaddition[0] =
            word.charAt(0).toUpperCase() + word.slice(1);
        }
      }
      let count = [
        ...results
          .reduce((mp, o) => {
            const key = JSON.stringify([o.cA_firstname, o.cA_lastname]);
            if (!mp.has(key)) mp.set(key, { ...o, count: 0 });
            mp.get(key).count++;
            return mp;
          }, new Map())
          .values(),
      ];
      return count.sort((a, b) => a.cA_firstname > b.cA_firstname);
    },
    setMissingPlaceFacets(results) {
      for (var result in results) {
        results[result] = fillMissingKeys(results[result], {
          cA_placeName: "",
          cA_country: "",
          cA_type: "",
        });
        var word = results[result].cA_placeName[0];
        if (word) {
          results[result].cA_placeName[0] =
            word.charAt(0).toUpperCase() + word.slice(1);
        }
      }
      let count = [
        ...results
          .reduce((mp, o) => {
            const key = JSON.stringify([o.cA_placeName]);
            if (!mp.has(key)) mp.set(key, { ...o, count: 0 });
            mp.get(key).count++;
            return mp;
          }, new Map())
          .values(),
      ];
      return count.sort((a, b) => a.cA_placeName > b.cA_placeName);
    },
  },

  async mounted() {
    const { total, results, facets } = await this.api.fetchTagResults({
      facets: "type",
    });
    this.facets = facets.type;
  },
};
</script>

<style>
.is-unstyled {
  list-style: none !important;
  margin-left: 0 !important;
}
</style>
